module.exports = __webpack_public_path__ + "img/2.929f26fc.svg";